export const ecologicalCooperationSharePlatformEN = {
  title: "Ecosystems",
  subtitle: "Collaborating for reciprocal advantages",
  territory: {
    title:
      "Frontier of High-Fidelity Simulation in AI and Spatial Intelligence Validation and Verification",
    video: require("@/static/img/v_en.mp4"),
  },
  press: {
    title: "Alliance Updates",
    subtitle:
      "We are committed to creating new vitality for the AI and spatial intelligence simulation industry.",
    list: [
      {
        title:
          "PilotD Automotive and STEP AI have reached a strategic partnership to enhance the efficiency of automated driving R&D through a strong alliance",
      },
      {
        title:
          "PilotD Automotive and WICV have signed a strategic partnership agreement to jointly create a new future of intelligent interconnected vehicles",
      },
      {
        title:
          "PilotD Automotive and Chuhang Technology have reached a strategic partnership agreement",
      },
      {
        title:
          "PilotD Automotive and PhiGent Robotics have reached a bidirectional strategic partnership",
      },
      {
        title:
          'PilotD Automotive and Shanghai Second University of Technology jointly established in-the-loop DiL simulation laboratory, building a "partner circle" for industry-academia-research collaboration',
      },
      {
        title:
          "PilotD Automotive Technology x Zhejiang Intelligent Connected Vehicle Innovation Center, jointly created a new pattern of smart mobility!",
      },
      {
        title:
          "PilotD Automotive and VCARSYSTEM Electronic Technology have reached a strategic partnership!",
      },
      {
        title:
          "PilotD Automotive collaborated with ZD Technology to create a V2X full simulation ecosystem, covering a massive amount of  simulation-based V2X test scenarios",
      },
    ],
  },
};
export const ecologicalCooperationSharePlatformCN = {
  title: "Ecosystems 生态朋友圈",
  subtitle: "携手并进，互惠共赢",
  territory: {
    title: "AI与空间智能验证与确认中的高保真仿真前沿",
    video: require("@/static/img/v.mp4"),
  },
  press: {
    title: "合作资讯",
    subtitle: "我们致力于为AI与空间智能仿真行业注入新活力",
    list: [
      {
        title: "沛岱汽车与足下科技达成战略合作，强强联合提升自动驾驶研发效能",
      },
      {
        title: "沛岱汽车与西部智联签署战略合作协议，共创智能网联汽车新未来",
      },
      {
        title: "沛岱汽车与楚航科技达成战略合作",
      },
      {
        title: "沛岱汽车与鉴智机器人达成双向战略合作",
      },
      {
        title:
          "沛岱汽车与上海第二工业大学共建在环仿真DiL实验室,构建产学研“朋友圈”",
      },
      {
        title:
          "合作共赢！沛岱汽车技术×浙江省智能网联汽车创新中心，共创智慧出行新格局！",
      },
      {
        title: "强强联手，打造共赢模式|沛岱汽车与昆易电子科技达成战略合作！",
      },
      {
        title: "沛岱汽车携手知迪打造V2X全仿真生态，覆盖海量V2X场景仿真测试",
      },
    ],
  },
};
